// extracted by mini-css-extract-plugin
export var root = "TR1ujA4EUeZZsy3MemWC";